class BaseGeocodeService {
  /**
   * Get reversed geocoded address
   *
   * @param {Latitude} latitude
   * @param {Longitude} longitude
   */
  async reverseGeocode (latitude, longitude) {
    throw new Error('Not implemented.')
  }
}

export default BaseGeocodeService



// WEBPACK FOOTER //
// ./src/services/geocoding/baseGeocodeService.js